import styled from "styled-components";
import { colors, screenSizes } from "@storeblocks/global-styles";

export const AppContent = styled.main`
  background-color: ${colors.grey.grey20};
  color: black;
  display: flex;
  font-size: 16px;
  min-height: calc(100vh - var(--const-footer));
  text-align: initial;
`;

export const RouterContainer = styled.div`
  margin: 0px auto;
  max-width: 1112px;
  padding: 0px 16px 24px 16px;
  width: 100%;

  @media only screen and (max-width: ${screenSizes.desktop}px) {
    max-width: 100%;
    padding: 0px 16px;
    width: 100%;
  }
`;

export const SpinnerWrapper = styled.div`
  align-self: center;
  display: flex;
  padding: 42px 0px;
  width: 100%;
`;
